import { Component, OnInit, Input, HostBinding, Inject, PLATFORM_ID } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { ActivatedRoute, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie';
import { ApiService } from '../../services/api.service';
import { AuthService } from '../../services/auth.service';
import { LoaderServices } from '../../services/loader.service';
import firebase from 'firebase/compat/app';
import { HttpErrorResponse } from '@angular/common/http';
import { FirebaseCloudFunctionsService } from '../../services/firebase-cloud-functions.service';
import { lastValueFrom } from 'rxjs';
import { FirestoreService } from '../../services/firestore.service';
import { UserApiService } from '../../services/user-api.service';
import { SubscriptionService } from '../../services/subscription.service';
import { AnalyticsUtils } from '../../services/analytics-utils';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UserOnboardingServeComponent } from '../user-onboarding-serve/user-onboarding-serve.component';
import { SharedService } from '../../services/shared.service';
import { isPlatformBrowser } from '@angular/common';
// import { QuestionnaireModalComponent } from 'src/app/cabinet/questionnaire-modal/questionnaire-modal.component';
import { ReferrerTrackingService } from '../../services/referrer-tracking.service';
import { ReturnUrlService } from '../../services/return-url.service';
@Component({
    selector: 'app-google-signin',
    templateUrl: './google-signin.component.html',
    styleUrls: ['./google-signin.component.scss'],
    standalone: false
})
export class GoogleSigninComponent implements OnInit {
   public redirectURL: any;

   public messag: any;
   public token: any = null;
   @Input() click = '';
   @Input() tapEvent = '';
   @Input() completedEvent = '';
   @Input() failEvent = '';
   @Input() isGoogleBtnInsidePopup: boolean = false;
   private isBrowser: boolean;

   constructor(
      private apiService: ApiService,
      private auth: AuthService,
      private firestoreService: FirestoreService,
      private firebaseCloudFunctionService: FirebaseCloudFunctionsService,
      private router: Router,
      private cookie: CookieService,
      private route: ActivatedRoute,
      private loader: LoaderServices,
      public authFire: AngularFireAuth,
      private subscriptionService: SubscriptionService,
      public userApiService: UserApiService,
      private analyticsUtils: AnalyticsUtils,
      private modalService: NgbModal,
      private sharedService: SharedService,
      @Inject(PLATFORM_ID) private platformId: Object,
      private referrerTrackingService: ReferrerTrackingService,
      private returnUrlService: ReturnUrlService
   ) {
      this.isBrowser = isPlatformBrowser(this.platformId);
      if (this.isBrowser) {
         this.redirectURL = localStorage.getItem('redirectUrl');
      }
   }

   ngOnInit(): void {
      if (this.isBrowser) {
         this.returnUrlService.captureReturnUrl();
      }
   }

   async googleSign() {
      if (!this.isBrowser) {
         console.warn('Google Sign-in is not available in SSR context');
         return;
      }

      try {
         this.analyticsUtils.SOCIAL_AUTH_BTN_TAP(this.tapEvent);
         // await this.logout();

         const result = await this.authFire.signInWithPopup(
            new firebase.auth.GoogleAuthProvider()
         );

         await this.handleAuthSuccess(result);
      } catch (error) {
         this.handleAuthError(error);
      }
   }

   private async handleAuthSuccess(value: any) {
      try {
         const accessToken = value.credential.accessToken;
         this.loader.show();
         const loginData = {
            token: accessToken
         };

         const response: any = await this.userApiService.googleLogin(loginData);

         if (response.status) {
            await this.processSuccessfulLogin(response);
            this.referrerTrackingService.clearReferrerData();
         } else {
            this.handleLoginFailure(response);
         }
      } finally {
         this.loader.hide();
      }
   }

   private async processSuccessfulLogin(response: any) {
      const token = response.data;
      this.token = token;
      const isNew = response.is_new;
      if (this.isGoogleBtnInsidePopup) {
         this.auth.closeAuthPopup()
      }
      await this.auth.setToken(token);
      const userData: any = await this.userApiService.fetchUserDetailsAndSave();
      this.auth.setLoggedIn();

      if (!isNew) {
         await this.subscriptionService.setUserSubscriptionInfo();
      }
      await this.handleSubscriptionStatus(isNew, userData);
   }

   private async handleSubscriptionStatus(isNew: boolean, userData: any) {
      const subInfo = SubscriptionService.subscriptionData.getValue();
      if (subInfo.role === 'FREEMIUM') {
         if (isNew) {
            this.sharedService.afterSignUpActions(userData.email);
            this.analyticsUtils.SignupFlow_SaveUser_Completed('google');
            if(userData.sign_up_completed) {
               // this.modalService.open(UserOnboardingServeComponent, {
               //    centered: true,
               //    scrollable: true,
               //    size: 'xl',
               //    modalDialogClass: 'paywall-popup-modal',
               // });
               // this.modalService.open(QuestionnaireModalComponent, {
               //    modalDialogClass: 'paywall-popup-modal',
               //    centered: true,
               //    scrollable: true,
               //    backdrop: 'static',
               //    size: 'lg',
               // });
            }
         }
         // else this.subscriptionService.openPaywallModal();
      }
      this.analyticsUtils.SOCIAL_AUTH_COMPLETED(
         this.completedEvent,
         userData.email,
         isNew,
         AnalyticsUtils.METHOD_GOOGLE
      );
      if (this.isGoogleBtnInsidePopup) {
         window.location.reload();
      } else {
         // Check return_url first, then fall back to redirectURL from localStorage
         const returnUrl = this.returnUrlService.getReturnUrl();
         if (returnUrl) {
            this.returnUrlService.redirectAfterAuth('/', this.token);
         } else if (this.redirectURL) {
            this.router.navigateByUrl(this.redirectURL).then();
         } else {
            this.router.navigateByUrl('/');
         }
      }
   }

   private handleAuthError(error: any) {
      this.loader.hide();
      this.analyticsUtils.SOCIAL_AUTH_FAILED(
         this.failEvent,
         '',
         '',
         error.message
      );
      console.error('Google sign-in error:', error);
   }

   private handleLoginFailure(response: any) {
      this.messag = response.message;
      this.analyticsUtils.SOCIAL_AUTH_FAILED(
         this.failEvent,
         '',
         response.message,
         null
      );
   }

   private closePopup() {
      this.auth.closeAuthPopup()
   }

   async logout() {
      // const user = await this.authFire.currentUser;
      this.auth.logout();
      this.subscriptionService.clearSubscriptionInfo();
      // user?.delete();
      // await this.authFire.signOut();
   }

   @HostBinding('class')
   get googleBtnStyling(): string {
      if (this.isGoogleBtnInsidePopup) {
         return 'btn-styling';
      } else {
         return '';
      }
   }
}
